export default __webpack_public_path__ + "static/media/loading.b2ecd8e2.svg";